import { Grid } from "@material-ui/core";
import React from "react";
import "./Projects.scss";
import { Text, Input, Button, SelectBox } from "sunrise-ui";
import { AppDispatch } from "../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import {
  getUnitTypeData,
  getItemTypeData,
} from "../../redux/reducers/projectReducers";
import { uiSliceActions } from "../../redux/reducers/uiState";

const WorkOrderItems = ({
  triggered,
  changeBackToFalse,
  setWorkOrderItems,
  woCancel,
  setWoCancel,
}: {
  triggered: boolean;
  changeBackToFalse: any;
  setWorkOrderItems: any;
  woCancel: boolean;
  setWoCancel: any;
}) => {
  const editData = useSelector((state: any) => state.SPECIFICPROJECT.first);

  let initialItemState = {
    name: "",
    quantity: "",
    unit: "",
    rate: "",
    basicAmount: "",
  };
  const initialItemErrorState = {
    nameErr: false,
    quantityErr: false,
    unitErr: false,
    rateErr: false,
  };
  const createProjectData = useSelector(
    (state: any) => state.PROJECT.createProjectData
  );
  const updateProjectData = useSelector(
    (state: any) => state.PROJECT.updateProjectData
  );
  //----to get item name and unit from master data----
  const dispatch = useDispatch<AppDispatch>();
  React.useEffect(() => {
    dispatch(
      getItemTypeData({
        endPoint: "master-data/get-master-data?type=work-order",
      })
    );
    !unitTypes &&
      dispatch(
        getUnitTypeData({
          endPoint: "master-data/get-master-data?type=unit",
        })
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  const itemTypes = useSelector((state: any) => state.PROJECT.itemTypeData);
  const unitTypes = useSelector((state: any) => state.PROJECT.unitTypeData);

  //-----add item input state----
  let [state, setState] = React.useState([initialItemState]);
  let [errorState, setErrorState] = React.useState([initialItemErrorState]);

  //-----input on change handler----
  const handleChange = (index: number, e: any) => {
    const { name, value } = e.target;
    const list = [...state];
    const obj: any = {};
    obj[name] = value;
    const data = { ...list[index], ...obj };
    list[index] = data;

    // let inputs: any[] = [...state];
    // inputs[i][e.target.name] = e.target.value;
    if (name === "quantity") {
      const obj: any = {};
      obj["basicAmount"] = (
        Number(value) *
        (state[index]?.rate !== "" ? Number(state[index]?.rate) : 0)
      ).toFixed(2);
      const data = { ...list[index], ...obj };
      list[index] = data;
    }
    if (name === "rate") {
      const obj: any = {};
      obj["basicAmount"] = (
        Number(value) *
        (state[index]?.quantity !== "" ? Number(state[index]?.quantity) : 0)
      ).toFixed(2);
      const data = { ...list[index], ...obj };
      list[index] = data;
    }

    setState([...list]);
    setWorkOrderItems([...list]);
    let errors: any[] = [...errorState];
    errors[index][`${e.target.name}Err`] = false;
    setErrorState(errors);
    dispatch(uiSliceActions.setWorkOrderItemState([...list]));
  };

  //---- to add new input row---
  const handleAddItem = (type: any) => {
    let goodToGo = true;
    state?.forEach((item, index) => {
      if (state[index]?.name === "") {
        let errors: any[] = [...errorState];
        errors[index]["nameErr"] = true;
        setErrorState(errors);
        goodToGo = false;
      }
      if (state[index]?.quantity === "") {
        let errors: any[] = [...errorState];
        errors[index]["quantityErr"] = true;
        setErrorState(errors);
        goodToGo = false;
      }
      if (state[index]?.unit === "") {
        let errors: any[] = [...errorState];
        errors[index]["unitErr"] = true;
        setErrorState(errors);
        goodToGo = false;
      }
      if (state[index]?.rate === "") {
        let errors: any[] = [...errorState];
        errors[index]["rateErr"] = true;
        setErrorState(errors);
        goodToGo = false;
      }
    });

    if (goodToGo === true && type === "add") {
      setState([...state, initialItemState]);
      setWorkOrderItems([...state, initialItemState]);
      setErrorState([...errorState, initialItemErrorState]);
    }
    if (goodToGo === true && type === "blur") {
      dispatch(uiSliceActions.setWorkOrderItemState([...state]));
    }
  };
  const validiate = () => {
    let goodToGo = true;
    state?.forEach((item, index) => {
      if (state[index]?.name === "") {
        let errors: any[] = [...errorState];
        errors[index]["nameErr"] = true;
        setErrorState(errors);
        goodToGo = false;
      }
      if (state[index]?.quantity === "") {
        let errors: any[] = [...errorState];
        errors[index]["quantityErr"] = true;
        setErrorState(errors);
        goodToGo = false;
      }
      if (state[index]?.unit === "") {
        let errors: any[] = [...errorState];
        errors[index]["unitErr"] = true;
        setErrorState(errors);
        goodToGo = false;
      }
      if (state[index]?.rate === "") {
        let errors: any[] = [...errorState];
        errors[index]["rateErr"] = true;
        setErrorState(errors);
        goodToGo = false;
      }
    });
    if (goodToGo === true) {
      dispatch(uiSliceActions.setWorkOrderItemInitialState());
      dispatch(uiSliceActions.setWorkOrderItemState([...state]));
      dispatch(uiSliceActions.setIsworkItem(true));
    } else {
      dispatch(uiSliceActions.setInitalIsworkItem());
    }
  };
  React.useEffect(() => {
    dispatch(uiSliceActions.setWorkOrderItemInitialState());
    dispatch(uiSliceActions.setInitalIsworkItem());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  //---- to remove input row---
  const handleRemoveItem = (i: number) => {
    let inputs: any[] = [...state];
    inputs.splice(i, 1);
    setState(inputs);
    let inputsErr: any[] = [...errorState];
    inputsErr.splice(i, 1);
    setErrorState(inputsErr);
    setWorkOrderItems(inputs);
    dispatch(uiSliceActions.setWorkOrderItemState([...inputs]));
  };

  const changeResetname = () => {};
  const changeResetUnit = () => {};
  //-----props work ---
  React.useEffect(() => {
    if (triggered) {
      validiate();
      changeBackToFalse();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggered]);
  React.useEffect(() => {
    if (woCancel) {
      handleCancel();
      setWoCancel(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [woCancel]);

  //---if edit is triggered---
  React.useEffect(() => {
    if (editData?.type === "edit") {
      dispatch(uiSliceActions.setWorkOrderItemInitialState());
      dispatch(uiSliceActions.setInitalIsworkItem());

      let data: any[] =
        editData?.projectDetail?.workOrderInformation?.workOrderItemDetails;

      let newErrItems: any[] = [];
      for (let i = 0; i < data.length; i++) {
        newErrItems.push(initialItemErrorState);
      }
      setErrorState(newErrItems);
      const result = data.map(({ _id, ...rest }) => ({ ...rest }));
      setState(result);
      dispatch(uiSliceActions.setWorkOrderItemState(result));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editData]);
  //--if project is added or updated--
  React.useEffect(() => {
    if (createProjectData?.status || updateProjectData?.status) {
      handleCancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createProjectData, updateProjectData]);

  const handleCancel = () => {
    setState([initialItemState]);
    setErrorState([initialItemErrorState]);
    dispatch(uiSliceActions.setWorkOrderItemInitialState());
    dispatch(uiSliceActions.setInitalIsworkItem());
  };

  return (
    <Grid container className="work_order_items_wrapper">
      {/* ----work order item details------ */}

      <Grid>
        {state &&
          state?.map((item: any, index: number) => (
            <Grid item xs={12} container spacing={2}>
              <Grid item xs={12} container className="sb">
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={18}
                  className="mb0 mt fw500"
                >
                  Work Order Item {index + 1} Details*
                </Text>
                {state?.length > 1 && (
                  <Button
                    type="button"
                    size="small"
                    isRounded={true}
                    category="warning"
                    onClick={() => {
                      handleRemoveItem(index);
                    }}
                    className="mb0 pl pr delete_button"
                  >
                    <span
                      className="iconify"
                      data-icon="fluent:delete-16-regular"
                    ></span>
                    &nbsp; Delete&nbsp;Item
                  </Button>
                )}
              </Grid>
              {/* ----------work order item names------ */}
              <Grid item xs={4}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb0 mt0"
                >
                  <span className="fw500">
                    Work Order Item {index + 1} Name*
                  </span>
                </Text>
                <SelectBox
                  data={[...itemTypes]}
                  placeHolder="Select Item Name"
                  defaultVal={state[index]?.name?.toString()}
                  onChange={(event) => {
                    handleChange(index, event);
                  }}
                  borderColor={
                    errorState[index]?.nameErr ? "danger" : "primary"
                  }
                  name="name"
                  resetVal={
                    state[index]?.name?.toString() === "" ? true : false
                  }
                  changeReset={changeResetname}
                />
                <Text
                  type={errorState[index]?.nameErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    errorState[index]?.nameErr
                      ? "mb0 mt0 float-right"
                      : "d-none"
                  }
                >
                  Please Select Item Name.
                </Text>
              </Grid>
              {/* ----------quantity of item------ */}
              <Grid item xs={2}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt0"
                >
                  <span className="fw500">Quantity of Item*</span>
                </Text>
                <Input
                  color={
                    errorState[index]?.quantityErr &&
                    state[index]?.quantity === ""
                      ? "danger"
                      : "primary"
                  }
                  fonts="normal"
                  placeholder="Enter Here"
                  name="quantity"
                  value={state[index]?.quantity}
                  min={1}
                  type="number"
                  onChange={(event) => {
                    if(!/^\d{0,8}(\.\d{0,2})?$/.test(event.target.value)) {
                      return false;
                    } else {
                      handleChange(index, event);
                    }
                  }}
                />
                <Text
                  type={
                    errorState[index]?.quantityErr &&
                    state[index]?.quantity === ""
                      ? "danger"
                      : "normal"
                  }
                  fonts="normal"
                  fontSize={12}
                  className={
                    errorState[index]?.quantityErr &&
                    state[index]?.quantity === ""
                      ? "mb0 mt0 float-right"
                      : "d-none"
                  }
                >
                  Please Enter Quantity.
                </Text>
              </Grid>
              {/* ----------quantity of item------ */}
              <Grid item xs={2}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb0 mt0"
                >
                  <span className="fw500">Unit of Item*</span>
                </Text>
                <SelectBox
                  data={[...unitTypes]}
                  placeHolder="Select Unit"
                  name="unit"
                  defaultVal={state[index]?.unit?.toString()}
                  onChange={(event) => {
                    handleChange(index, event);
                  }}
                  borderColor={
                    errorState[index]?.unitErr ? "danger" : "primary"
                  }
                  resetVal={
                    state[index]?.unit?.toString() === "" ? true : false
                  }
                  changeReset={changeResetUnit}
                />
                <Text
                  type={errorState[index]?.unitErr ? "danger" : "normal"}
                  fonts="normal"
                  fontSize={12}
                  className={
                    errorState[index]?.unitErr
                      ? "mb0 mt0 float-right"
                      : "d-none"
                  }
                >
                  Please Select Unit.
                </Text>
              </Grid>
              {/* ----------Rate------ */}
              <Grid item xs={2}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt0"
                >
                  <span className="fw500">Rate (Rs)*</span>
                </Text>
                <Input
                  color={
                    errorState[index]?.rateErr && state[index]?.rate === ""
                      ? "danger"
                      : "primary"
                  }
                  fonts="normal"
                  placeholder="Enter Here"
                  name="rate"
                  value={state[index]?.rate}
                  type="number"
                  min={1}
                  onChange={(event) => {
                    if(!/^\d{0,10}(\.\d{0,2})?$/.test(event.target.value))
                    return false;
                    else {
                      handleChange(index, event);
                    }
                  }}
                  onBlur={() => handleAddItem("blur")}
                />
                <Text
                  type={
                    errorState[index]?.rateErr && state[index]?.rate === ""
                      ? "danger"
                      : "normal"
                  }
                  fonts="normal"
                  fontSize={12}
                  className={
                    errorState[index]?.rateErr && state[index]?.rate === ""
                      ? "mb0 mt0 float-right"
                      : "d-none"
                  }
                >
                  Please Enter Rate.
                </Text>
              </Grid>
              {/* ----------Basic Amount------ */}
              <Grid item xs={2}>
                <Text
                  type="normal"
                  fonts="normal"
                  fontSize={16}
                  className="mb mt0"
                >
                  <span className="fw500">Basic Amount (Rs)*</span>
                </Text>
                <Input
                  color={"primary"}
                  fonts="normal"
                  placeholder="Enter Here"
                  name="basicAmount"
                  value={parseFloat(state[index]?.basicAmount).toFixed(2)}
                  type="number"
                  min={1}
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="button"
                  size="small"
                  isRounded={true}
                  category="primary"
                  onClick={() => {
                    handleAddItem("add");
                  }}
                  className={
                    state && state?.length === index + 1
                      ? "submit_button mb1 pl pr"
                      : "d-none"
                  }
                >
                  + Add Item
                </Button>
              </Grid>
            </Grid>
          ))}
      </Grid>
    </Grid>
  );
};

export default WorkOrderItems;
